import { connect } from 'react-redux';
import HierarchyKeyFigureVisualizer from './hierarchy-key-figure-visualizer';

import { selectLocation, selectReport } from '../../../../reducers/reports.reducers';


const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({
  selectLocation: locationId => dispatch(selectLocation(locationId)),
  selectReport: reportId => dispatch(selectReport(reportId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HierarchyKeyFigureVisualizer);
